@if (shellChromeVisible()) {
  <app-skip-link targetId="content" />
  <app-top-bar />
}
<div class="shell" [class.shell-public]="!shellChromeVisible()">
  @if (shellChromeVisible() && layout.sidebarPresentation() !== 'drawer') {
    <app-sidebar />
  }
  <div class="shell-body">
    @if (shellChromeVisible()) {
      @if (filterBarVisible()) {
        <app-filter-bar />
      }
    }
    <main id="content" tabindex="-1" class="shell-content" [class.shell-content-public]="!shellChromeVisible()">
      <router-outlet />
    </main>
  </div>
</div>
@if (shellChromeVisible() && layout.sidebarPresentation() === 'drawer' && layout.drawerOpen()) {
  <app-sidebar-drawer />
}
